import React from "react";
import {Collapse, IconButton} from "@material-tailwind/react";
import * as IconsMui from "@mui/icons-material";
import {ItemInfoSpouse} from "../../components/ViewData";
import * as IconMaterial from "@mui/icons-material";
import {EconomicActivitySriInterface} from "../../../services/interface/sri/economic-activity-sri-interface";
import {useTranslation} from "react-i18next";

interface Props {
    nivel: number;
    economicActivity?: EconomicActivitySriInterface;
}
export default function Activity({nivel, economicActivity}: Props) {
    const { t } = useTranslation("global") as { t: (key: string) => string };
    const [isOpen, setIsOpen] = React.useState(false);

    const toggleIsNavOpen = () => setIsOpen((cur) => !cur);
    const styleIcon = 'max-w-[20px] max-h-[20px]'

    return (
        <>
            <div className={'custom-card p-2'}>
                <div className={'flex flex-row gap-3'}>
                    <div className={'flex flex-row w-full gap-3 items-center'}>
                        <h6>{`${t('level')} ${(nivel + 1)}`}</h6>
                        <IconButton
                            className={'ml-auto'}
                            placeholder="icon-button"
                            size="sm"
                            variant="text"
                            onClick={toggleIsNavOpen}
                        >
                            <IconsMui.KeyboardArrowDownTwoTone className="h-6 w-6 text-empColorPrimary"/>
                        </IconButton>
                    </div>
                </div>
                <Collapse open={isOpen} className="bg-white grid grid-cols-1 sm:grid-cols-2 gap-2">
                    <ItemInfoSpouse
                        label={t('code-CIIU')}
                        text={economicActivity?.codeCIIU}
                        className={'text-[13px]'}
                        icon={<IconMaterial.HelpTwoTone className={styleIcon}/>}
                    />
                    <ItemInfoSpouse
                        label={`${t('description')}`}
                        text={economicActivity?.description}
                        className={'text-[13px]'}
                    />
                </Collapse>
            </div>
        </>
    )
}
